module.exports = __webpack_public_path__ + "static/img/test-infectious-disease.5678426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reproductive/test-infectious-disease.jpg
// module id = E9J4
// module chunks = 0